// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__dialog___1B3kZ {\n  max-height: 90%;\n  display: flex\n}\n\n.css__dialog___1B3kZ > div:first-of-type {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    color: var(--color-text);\n  }\n\n.css__itemGrid___fvbcf {\n  min-height: 150px;\n  margin-left: -12px;\n  margin-right: -12px;\n  overflow-y: auto;\n}\n\n.css__groupedActions___ZlPEp {\n  display: flex;\n}\n\n.css__textWarning___3z6hP {\n  font-weight: bold !important;\n}\n\n.css__confirmField___3lyGh {\n  margin-top: 0;\n}", ""]);
// Exports
exports.locals = {
	"dialog": "css__dialog___1B3kZ",
	"itemGrid": "css__itemGrid___fvbcf",
	"groupedActions": "css__groupedActions___ZlPEp",
	"textWarning": "css__textWarning___3z6hP",
	"confirmField": "css__confirmField___3lyGh"
};
module.exports = exports;
